import { Routes, Route } from 'react-router-dom';
// eslint-disable-next-line max-len
import { type ConfiguratorApplicationEntrypointContextDataFragment } from '../../../api/fragments/ConfiguratorApplicationEntrypointContextData';
import { useThemeComponents } from '../../../themes';
import SessionRevokedPage from '../SessionRevokedPage';
import AcknowledgementInfoPage from '../StandardApplicationEntrypoint/AcknowledgementInfoPage';
import CustomerValidationPage from '../StandardApplicationEntrypoint/CustomerValidationPage';
import Journey from './Journey';

export type PublicAccessEntrypointProps = {
    endpoint: ConfiguratorApplicationEntrypointContextDataFragment;
};

const PublicAccessEntrypoint = ({ endpoint }: PublicAccessEntrypointProps) => {
    const { ConfiguratorLayout } = useThemeComponents();

    return (
        <Routes>
            <Route key="authorize" element={<CustomerValidationPage layout={ConfiguratorLayout} />} path="authorize" />
            <Route key="apply" element={<Journey endpoint={endpoint} />} path="apply" />
            <Route key="sessionRevoked" element={<SessionRevokedPage />} path="sessionRevoked" />
            <Route key="thankyou" element={<AcknowledgementInfoPage />} path="thankyou" />
        </Routes>
    );
};

export default PublicAccessEntrypoint;
